<template>
  <Layout>
    <div class="mb6 mt12 contianer">
      <template v-if="isFee">
        <PdfDetail v-if="type==='academ'"></PdfDetail>
        <NewsDetail v-else></NewsDetail>
      </template>
      <exchange v-else :detail="this.detail" :isFee.sync="isFee"></exchange>
    </div>
  </Layout>
</template>

<script>
import Layout from '../../layout';
import NewsDetail from '../../components/article/Detail';
import PdfDetail from '../../components/pdfDetail'
import Exchange from '../../components/exchange';
export default {
  metaInfo() {
    return {
      meta: [{
        name: 'description',
        content: '敏思 敏思中文版临床资讯与新闻不同临床专科的最新资讯与新闻，包括医学继续教育、临床研究和试验、研讨会报道及药物开发与研究等。'
      }]
    }
  },
  data () {
    let { id, type, ResType } = this.$utils.query2Obj(location.search);
    return {
      type,
      id,
      ResType,
      detail: null,
      loading:true,
      isFee:false
    }
  },
  components: {
    Exchange,
    Layout,
    NewsDetail,
    PdfDetail
  },
  created() {
    let resType = 2;
    console.log(this.type)
    if(this.type==='meidihui'){
      resType=5;
    }else if(this.type==='meeting'){
      resType=4;
    }else if(this.type==='news'){
      resType=2;
    }else if(this.type==='disease'){
      resType=4;
    }else if(this.type==='academ'){
      resType=6;
    }
    this.$apis.resources.checkAuth({Id:this.id,ResType:resType}).then(result=>{
      this.isFee = result.isFee;
      this.detail = result.feeDetail;
    });
    this.loading = false;
  },
};
</script>

<style lang="scss"></style>
